import { render } from "./Langs.vue?vue&type=template&id=1ac31c16&scoped=true&ts=true"
import script from "./Langs.vue?vue&type=script&lang=ts"
export * from "./Langs.vue?vue&type=script&lang=ts"

import "./Langs.vue?vue&type=style&index=0&id=1ac31c16&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ac31c16"]])

export default __exports__